import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateEmailComponent } from './update-email/update-email.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UpdateAddressModalComponent } from './update-address-modal/update-address-modal.component';
import { BusyMessageModalComponent } from './busy-message-modal/busy-message-modal.component';
import { GoBackButtonComponent } from './go-back-button/go-back-button.component';

@NgModule({
	declarations: [
		BusyMessageModalComponent,
		GoBackButtonComponent,
		UpdateAddressModalComponent,
		UpdateEmailComponent
	],
	imports: [ CommonModule, ModalModule.forRoot(), ReactiveFormsModule ],
	exports: [ BusyMessageModalComponent, GoBackButtonComponent, UpdateAddressModalComponent, UpdateEmailComponent ],
	entryComponents: [ BusyMessageModalComponent, UpdateAddressModalComponent, UpdateEmailComponent ]
})
export class GlobalComponentsModule {}
